export function getSelectListValue(selectList, value) {
  return selectList.find((select) => select.value === value);
}

export const getCorrectBranchName = (branch) => {
  if (branch === "all") return "전체";
  if (branch === "부천점") return "부천점";
  if (branch === "광교점") return "광교점";
  if (branch === "인천점") return "인천점";
  if (branch === "반포점") return "반포점";
  return branch;
};

export function getInputValueOfNumberType(value) {
  let resultValue = value;
  if (value !== "0" && value[0] === "0") {
    resultValue = value.slice(1);
  }

  if (value === "") return 0;
  return Number(resultValue.replace(/[^0-9]/g, ""));
}

export const calculateFee = (price, percent) => {
  if (Number(price) <= 4000000) {
    return {
      a: Number(price) * +(percent.a / 100),
      b: 0,
      y: 0,
    };
  }

  if (Number(price) <= 10000000) {
    return {
      a: 4000000 * (percent.a / 100),
      b: (Number(price) - 4000000) * (percent.b / 100),
      y: 0,
    };
  }

  return {
    a: 4000000 * (percent.a / 100),
    b: 6000000 * (percent.b / 100),
    y: (Number(price) - 10000000) * (percent.y / 100),
  };
};

export function setDateTime(item, type, unit) {
  let setDate = "";
  if (item) {
    let basicDate = String(item).indexOf("-") > 0 || String(item).indexOf(".") > 0 
      ? String(item).replace(/[-.]/g, "/") 
      : item;
    let date = new Date(basicDate),
      yy,
      mm,
      dd,
      th,
      tm,
      ts;

    yy = date.getFullYear();
    mm = date.getMonth() + 1 <= 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    dd = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
    th = date.getHours() <= 9 ? "0" + date.getHours() : date.getHours();
    tm = date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes();
    ts = date.getSeconds() <= 9 ? "0" + date.getSeconds() : date.getSeconds();

    if (type === "yymmdd") {
      if (unit === "ymd") {
        setDate = yy + "년 " + mm + "월 " + dd + "일";
      } else if (unit === "hymd") {
        setDate = yy + "-" + mm + "-" + dd;
      } else if (unit === "not") {
        setDate = `${yy}${mm}${dd}`;
      } else {
        setDate = yy + "." + mm + "." + dd;
      }
    } else if (type === "yymmddhhtt") {
      if (unit === "ymd") {
        setDate = yy + "년 " + mm + "월 " + dd + "일 " + th + ":" + tm;
      } else if (unit === "hymd") {
        setDate = yy + "-" + mm + "-" + dd + " " + th + ":" + tm;
      } else {
        setDate = yy + "." + mm + "." + dd + " " + th + ":" + tm;
      }
    } else if (type === "mmdd") {
      if (unit === "ymd") {
        setDate = mm + "월 " + dd + "일";
      } else if (unit === "hymd") {
        setDate = mm + "-" + dd;
      } else if (unit === "slash") {
        setDate = mm + "/" + dd;
      } else {
        setDate = mm + "." + dd;
      }
    } else if (type === "yymm") {
      if (unit === "ymd") {
        setDate = yy + "년 " + mm + "월";
      } else if (unit === "hymd") {
        setDate = yy + "-" + mm;
      } else if (unit === "slash") {
        setDate = yy + "/" + mm;
      } else {
        setDate = yy + "." + mm;
      }
    } else if (type === "day") {
      setDate = dd;
    } else if (type === "yymmddhhttss") {
      if (unit === "ymd") {
        setDate = yy + "년 " + mm + "월 " + dd + "일 " + th + ":" + tm + ":" + ts;
      } else if (unit === "hymd") {
        setDate = yy + "-" + mm + "-" + dd + " " + th + ":" + tm + ":" + ts;
      } else {
        setDate = yy + "." + mm + "." + dd + " " + th + ":" + tm + ":" + ts;
      }
    } else if (type === "hhttss") {
      setDate = th + ":" + tm + ":" + ts;
    } else if (type === "hhtt") {
      setDate = th + ":" + tm;
    } else {
      setDate = yy + "." + mm + "." + dd + " " + th + ":" + tm + ":" + ts;
    }
  }
  return setDate;
}

/**
 * Phase 6d: branch dropdown 옵션을 user 권한으로 필터링.
 *  - 'all' 권한 → 입력 그대로 (전체 노출)
 *  - 권한 행 있음 → 본인 권한 지점만 + value="" ("전체 of 권한") 옵션 유지
 *  - 권한 정보 미수신 → 입력 그대로 (방어 — useLoad 보다 먼저 렌더되는 케이스 호환)
 *
 * @param {Array<{text:string,value:string}>} branchList - dropdown 옵션 배열
 * @param {object|null} user - useUser().user
 * @param {'malladmin'|'manageradmin'} app
 * @returns 필터된 옵션 배열
 */
export function filterBranchListByPermissions(branchList, user, app) {
  if (!Array.isArray(branchList)) return [];
  const perm = user?.permissions?.[app];
  if (!perm) return branchList;
  if (perm.is_all) return branchList;
  const allowedNames = (perm.branches || []).map((b) => b.name);
  return branchList.filter(
    (b) => b.value === "" || allowedNames.includes(b.value)
  );
}